module.exports = __webpack_public_path__ + "assets/images/profiles/2020-main-5.jpg?v=18efd1b9";